import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import HeaderBase, { NavLinks, NavLink, NavItem, LogoLink } from "components/headers/light.js";
import logo from "images/yenimahalle/yenimahalle_logo.png";
import { FaPhone } from "react-icons/fa";

const FixedHeader = styled(HeaderBase)`
  ${tw`
    fixed top-0 left-0 w-full z-50 bg-white shadow p-6
    max-w-none!
  `}
  margin: 0 !important;
`;

const Dropdown = tw.div`relative inline-block`;
const DropdownTrigger = tw.div`cursor-pointer inline-block`;
const DropdownContent = styled.div`
  ${tw`absolute bg-white shadow-md rounded z-10 p-4`}
  top: 100%;
  left: 0;
  display: grid;
  grid-template-columns: repeat(3, minmax(150px, 1fr));
  gap: 1rem;
  min-width: 450px;
  z-index: 100;
`;
const DropdownCategory = tw.div`flex flex-col`;
const DropdownCategoryHeader = tw.div`font-bold text-gray-700 mb-2`;
const DropdownItem = tw.a`
  text-gray-700 font-thin block p-1
  hover:bg-gray-100 hover:text-primary-500
  rounded
`;

const DesktopDropdownMenu = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  return (
    <Dropdown
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
    >
      <DropdownTrigger>Kurumsal</DropdownTrigger>
      {isOpen && (
        <DropdownContent
          onMouseEnter={() => setIsOpen(true)}
          onMouseLeave={() => setIsOpen(false)}
        >
          <DropdownCategory>
            <DropdownCategoryHeader>Başkan</DropdownCategoryHeader>
            <DropdownItem href="/Icerik/BaskaninOzgecmisi/2">
              Başkanın Özgeçmişi
            </DropdownItem>
            <DropdownItem href="/Icerik/BaskaninMesaji/1">
              Başkanın Mesajı
            </DropdownItem>
            <DropdownItem href="//https://fethiyasar.com.tr/">
              Kişisel Web Sayfası
            </DropdownItem>
            <DropdownItem href="/Album/FethiYasar">
              Başkanımızla Fotoğraflar
            </DropdownItem>
          </DropdownCategory>
          <DropdownCategory>
            <DropdownCategoryHeader>Kurumsal</DropdownCategoryHeader>
            <DropdownItem href="/Icerik/YenimahalleHakkinda/3">
              Yenimahalle Hakkında
            </DropdownItem>
            <DropdownItem href="/Icerik/YonetimSemasi/65">
              Yönetim Şeması
            </DropdownItem>
            <DropdownItem href="/BaskanYardimcilari">
              Başkan Yardımcıları
            </DropdownItem>
            <DropdownItem href="/Icerik/Mevzuatimiz/4">
              Mevzuatımız
            </DropdownItem>
            <DropdownItem href="/MeclisUyeleri">
              Meclis Üyeleri
            </DropdownItem>
            <DropdownItem href="/Mudurlukler">
              Müdürlükler
            </DropdownItem>
          </DropdownCategory>
          <DropdownCategory>
            <DropdownCategoryHeader>Diğer</DropdownCategoryHeader>
            <DropdownItem href="/Muhtarlar">Muhtarlar</DropdownItem>
            <DropdownItem href="/MeclisGundemi">Meclis Gündemi</DropdownItem>
            <DropdownItem href="/MeclisKararlari">Meclis Kararları</DropdownItem>
            <DropdownItem href="/Icerik/Belgelerimiz/00">Belgelerimiz</DropdownItem>
          </DropdownCategory>
        </DropdownContent>
      )}
    </Dropdown>
  );
};

const useIsMobile = () => {
  const [isMobile, setIsMobile] = React.useState(false);
  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return isMobile;
};

const MobileDropdownMenu = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const toggleDropdown = () => setIsOpen(!isOpen);

  return (
    <div>
      <div onClick={toggleDropdown} css={tw`cursor-pointer pb-2`}>
        <NavLink tw="hover:text-primary-500">Kurumsal</NavLink>
      </div>
      {isOpen && (
        <div
          css={[
            tw`bg-white shadow-md rounded mt-2 p-4`,
            { maxHeight: "20rem", overflowY: "auto" },
          ]}
        >
          <NavItem tw="mt-4 border-gray-200">Başkan</NavItem>
          <NavLink
            href="/Icerik/BaskaninOzgecmisi/2"
            tw="block font-thin my-1"
          >
            Başkanın Özgeçmişi
          </NavLink>
          <NavLink
            href="/Icerik/BaskaninMesaji/1"
            tw="block font-thin my-1"
          >
            Başkanın Mesajı
          </NavLink>
          <NavLink
            href="//https://fethiyasar.com.tr/"
            tw="block font-thin my-1"
          >
            Kişisel Web Sayfası
          </NavLink>
          <NavLink
            href="/Album/FethiYasar"
            tw="block font-thin my-1"
          >
            Başkanımızla Fotoğraflar
          </NavLink>

          <NavItem tw="mt-4 border-gray-200">Kurumsal</NavItem>
          <NavLink
            href="/Icerik/YenimahalleHakkinda/3"
            tw="block font-thin my-1"
          >
            Yenimahalle Hakkında
          </NavLink>
          <NavLink
            href="/Icerik/YonetimSemasi/65"
            tw="block font-thin my-1"
          >
            Yönetim Şeması
          </NavLink>
          <NavLink
            href="/BaskanYardimcilari"
            tw="block font-thin my-1"
          >
            Başkan Yardımcıları
          </NavLink>
          <NavLink
            href="/Icerik/Mevzuatimiz/4"
            tw="block font-thin my-1"
          >
            Mevzuatımız
          </NavLink>
          <NavLink
            href="/MeclisUyeleri"
            tw="block font-thin my-1"
          >
            Meclis Üyeleri
          </NavLink>
          <NavLink
            href="/Mudurlukler"
            tw="block font-thin my-1"
          >
            Müdürlükler
          </NavLink>

          <NavItem tw="mt-4 border-gray-200">Diğer</NavItem>
          <NavLink href="/Muhtarlar" tw="block font-thin my-1">
            Muhtarlar
          </NavLink>
          <NavLink href="/MeclisGundemi" tw="block font-thin my-1">
            Meclis Gündemi
          </NavLink>
          <NavLink href="/MeclisKararlari" tw="block font-thin my-1">
            Meclis Kararları
          </NavLink>
          <NavLink
            href="/Icerik/Belgelerimiz/00"
            tw="block font-thin my-1"
          >
            Belgelerimiz
          </NavLink>
        </div>
      )}
    </div>
  );
};

const DesktopPlansDropdownMenu = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  return (
    <Dropdown
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
    >
      <DropdownTrigger  style={{ display: "none" }}>Planlar, Raporlar ve Kararlar</DropdownTrigger>
      {isOpen && (
        <DropdownContent
          onMouseEnter={() => setIsOpen(true)}
          onMouseLeave={() => setIsOpen(false)}
          // 1 sütun yeterli; daha uzun listeler için min-width korundu
          style={{ gridTemplateColumns: "repeat(1, minmax(250px, 1fr))" }}
        >
          <DropdownCategory>
            <DropdownItem href="#">
              Stratejik Planlar
            </DropdownItem>
            <DropdownItem href="#">
              İmar Planı Değişiklikleri
            </DropdownItem>
            <DropdownItem href="#">
              Performans Programları
            </DropdownItem>
            <DropdownItem href="#">
              Faaliyet Raporları
            </DropdownItem>
            <DropdownItem href="/MeclisKararlari">
              Meclis Kararları
            </DropdownItem>
            <DropdownItem href="/Icerik/meclis-gundemi/42">
              Meclis Gündemi
            </DropdownItem>
            <DropdownItem href="#">
              İç Kontrol Eylem Planı
            </DropdownItem>
            <DropdownItem href="#">
              Yönetmelikler
            </DropdownItem>
            <DropdownItem href="/Icerik/kvkk/44">
              KVKK Bilgilendirme Metinleri ve Başvuru Formu
            </DropdownItem>
          </DropdownCategory>
        </DropdownContent>
      )}
    </Dropdown>
  );
};

const MobilePlansDropdownMenu = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const toggleDropdown = () => setIsOpen(!isOpen);

  return (
    <div  style={{ display: "none" }}>
      <div onClick={toggleDropdown} css={tw`cursor-pointer pb-2`}>
        <NavLink tw="hover:text-primary-500">
          Planlar, Raporlar ve Kararlar
        </NavLink>
      </div>
      {isOpen && (
        <div
          css={[
            tw`bg-white shadow-md rounded mt-2 p-4`,
            { maxHeight: "20rem", overflowY: "auto" },
          ]}
        >
          <NavLink href="#" tw="block font-thin my-1">
            Stratejik Planlar
          </NavLink>
          <NavLink href="#" tw="block font-thin my-1">
            İmar Planı Değişiklikleri
          </NavLink>
          <NavLink href="#" tw="block font-thin my-1">
            Performans Programları
          </NavLink>
          <NavLink href="#" tw="block font-thin my-1">
            Faaliyet Raporları
          </NavLink>
          <NavLink href="/MeclisKararlari" tw="block font-thin my-1">
            Meclis Kararları
          </NavLink>
          <NavLink href="/Icerik/meclis-gundemi/42" tw="block font-thin my-1">
            Meclis Gündemi
          </NavLink>
          <NavLink href="#" tw="block font-thin my-1">
            İç Kontrol Eylem Planı
          </NavLink>
          <NavLink href="#" tw="block font-thin my-1">
            Yönetmelikler
          </NavLink>
          <NavLink href="/Icerik/kvkk/44" tw="block font-thin my-1">
            KVKK Bilgilendirme Metinleri ve Başvuru Formu
          </NavLink>
        </div>
      )}
    </div>
  );
};


// Arama formu stilleri
const SearchForm = styled.form`
  ${tw`relative flex items-center`}
`;
const SearchInput = styled.input`
  ${tw`border border-gray-300 rounded-full py-1 px-4 text-sm focus:outline-none focus:ring-2 focus:ring-primary-500`}
  width: 12rem;
  transition: width 200ms;

  &:focus {
    width: 24rem;
  }
`;

export default () => {
  const isMobile = useIsMobile();
  const [searchTerm, setSearchTerm] = React.useState("");

  const handleSearch = (e) => {
    e.preventDefault();
    if (!searchTerm.trim()) return;  // Boşsa hiçbir şey yapma
    const query = encodeURIComponent(searchTerm);
    const url = `https://www.google.com.tr/search?domains=www.yenimahalle.bel.tr&sitesearch=www.yenimahalle.bel.tr&q=${query}`;
    window.open(url, "_blank");
  };

  const navLinks = [
    <NavLinks key={1}>
      <NavLink href="/">Ana Sayfa</NavLink>
      {isMobile ? (
        <MobileDropdownMenu />
      ) : (
        <NavItem>
          <DesktopDropdownMenu />
        </NavItem>
      )}
      <NavLink href="/icerik/BilgiEdinme/54">Bilgi Edinme</NavLink>
      <NavLink href="/Yonlendirme/Hizmetlerimiz/1">Hizmetler</NavLink>
      <NavLink href="/Iletisim">İletişim</NavLink>
      {isMobile ? (
        <MobilePlansDropdownMenu />
      ) : (
        <NavItem>
          <DesktopPlansDropdownMenu />
        </NavItem>
      )}
      {/* <NavLink href="https://hizmet.yenimahalle.bel.tr/tr-TR/Company?id=24&t=QGLLH" target="_blank">Yardım Portalı </NavLink> */}
      {/* Masaüstü arama */}
      {!isMobile && (
        <NavItem tw="ml-6 flex justify-center">  {/* flex + justify-center */}
          <SearchForm tw="mt-2" onSubmit={handleSearch}>
            <SearchInput
              type="text"
              placeholder="Ara..."
              aria-label="Site içinde ara"
              onChange={e => setSearchTerm(e.target.value)}
            />
          </SearchForm>
        </NavItem>
      )}
    </NavLinks>,

    <NavLinks key={2}>
      <NavItem tw="flex flex-col items-center xl:flex-row xl:items-center xl:ml-12!">
        <FaPhone tw="mr-2" />
        <div tw="text-center xl:text-left">
          <span tw="block xl:inline">0 (312)</span>
          <span tw="block xl:inline">870 11 11</span>
        </div>
      </NavItem>


      {/* Mobil arama */}
      {isMobile && (
        <NavItem tw="w-full mt-4 flex justify-center">  {/* flex + justify-center */}
          <SearchForm onSubmit={e => { e.preventDefault(); /* handleSearch */ }}>
            <SearchInput
              type="text"
              placeholder="Ara..."
              aria-label="Site içinde ara"
            />
          </SearchForm>
        </NavItem>
      )}
    </NavLinks>,
  ];

  return (
    <FixedHeader
      links={navLinks}
      logoLink={
        <LogoLink href="/">
          <img src={logo} alt="logo" />
          <div>
            <div>YENİMAHALLE BELEDİYESİ</div>
            <div>Kurumsal Web Sayfası</div>
          </div>
        </LogoLink>
      }
    />
  );
};
